import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["labelKey", "options", "valueKey", "className", "disabled", "value"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * @class SingleOtherPicker
 *
 * this component wraps `select` and adds some processing for `other` values.
 *
 */
import PropTypes from 'prop-types';
import React from 'react';
import SinglePicker from './singlePicker';
const SingleOtherPicker = _ref => {
  let _ref$labelKey = _ref.labelKey,
    labelKey = _ref$labelKey === void 0 ? 'name' : _ref$labelKey,
    options = _ref.options,
    _ref$valueKey = _ref.valueKey,
    valueKey = _ref$valueKey === void 0 ? 'id' : _ref$valueKey,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? '' : _ref$value,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  const newProps = _objectSpread(_objectSpread({}, otherProps), {}, {
    // with SingleOtherPicker, allowCreate is always true.
    allowCreate: true,
    options,
    labelKey,
    valueKey,
    className: "".concat(className, " t-sop"),
    disabled,
    value
  });
  return /*#__PURE__*/React.createElement(SinglePicker, newProps);
};
SingleOtherPicker.propTypes = {
  className: PropTypes.string,
  labelKey: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  valueKey: PropTypes.string,
  disabled: PropTypes.bool
};
export default SingleOtherPicker;